export enum StorageKeys {
   TOKEN = "_cc",
   REFRESH_TOKEN = "_adc",
   LANGUAGE = "_adcc",
   USER = "_cc_dd",
   COUNTER = "_uc",
}
